import { CiTrophy } from "react-icons/ci";
import { GiRadarSweep } from "react-icons/gi";
import { FaBottleWater } from "react-icons/fa6";

const simulatorFeatures = [
  {
    icon: CiTrophy,
    title: "Simple & Competitive Play",
    desc: "Practice casually or switch to competition mode when you want a real challenge",
  },
  {
    icon: FaBottleWater,
    title: "Comfortable Session Experience",
    desc: "Stay refreshed with complimentary mineral water during every session",
  },
  {
    icon: GiRadarSweep,
    title: "Next-Gen Padel Training",
    desc: "Step into the future of padel with immersive simulator technology designed for fun and performance",
  },
];
export default simulatorFeatures;
